import * as THREE from 'three';
require('three-orbitcontrols');

import printModel from '../../../3dapps/mixins/printModel';
import { initThree, scene, camera, renderer, incRenderCount, createFloor } from './initThree';
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Range from 'vux/src/components/range/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XProgress from 'vux/src/components/x-progress/index.vue'
import Box from 'vux/src/components/box/index.vue'

import loading from '@/components/loading';
import { baseURL } from '@/request/request.js';
import { PaintingMaker } from './PaintingMaker';

import frame1 from '../imgs/边框1.svg';
import frame2 from '../imgs/边框2.svg';
import frame3 from '../imgs/边框3.svg';
import frame4 from '../imgs/边框4.svg';
import frame5 from '../imgs/边框5.svg';
import frame6 from '../imgs/边框6.svg';
import frame7 from '../imgs/边框7.svg';
import frame8 from '../imgs/边框8.svg';
import frame9 from '../imgs/边框9.svg';
import frame10 from '../imgs/边框10.svg';
import frame11 from '../imgs/边框11.svg';
import frame12 from '../imgs/边框12.svg';
import frame13 from '../imgs/边框13.svg';
import frame14 from '../imgs/边框14.svg';
import frame15 from '../imgs/边框15.svg';


import bian1 from '../imgs/边1.png';
import bian2 from '../imgs/边2.png';
import bian3 from '../imgs/边3.png';
import bian4 from '../imgs/边4.png';
import bian5 from '../imgs/边5.png';
import bian6 from '../imgs/边6.png';
import bian7 from '../imgs/边7.png';
import bian8 from '../imgs/边8.png';
import bian9 from '../imgs/边9.png';
import bian10 from '../imgs/边10.png';
import bian11 from '../imgs/边11.png';
import bian12 from '../imgs/边12.png';
import bian13 from '../imgs/边13.png';
import bian14 from '../imgs/边14.png';
import bian15 from '../imgs/边15.png';



import decorate1 from '../imgs/装饰1.svg';
import decorate2 from '../imgs/装饰2.svg';

import decorate4 from '../imgs/装饰4.svg';
import decorate5 from '../imgs/装饰5.svg';
import decorate6 from '../imgs/装饰6.svg';

import decorate8 from '../imgs/装饰8.svg';


import decorate11 from '../imgs/装饰11.svg';

import zhuang1 from '../imgs/装1.png';
import zhuang2 from '../imgs/装2.png';

import zhuang4 from '../imgs/装4.png';
import zhuang5 from '../imgs/装5.png';
import zhuang6 from '../imgs/装6.png';

import zhuang8 from '../imgs/装8.png';


import zhuang11 from '../imgs/装11.png';


import decoraPain1 from '../imgs/剪纸1.svg';
import decoraPain2 from '../imgs/剪纸2.svg';
import decoraPain3 from '../imgs/剪纸3.svg';
import decoraPain4 from '../imgs/剪纸4.svg';

import jian1 from '../imgs/剪1.png';
import jian2 from '../imgs/剪2.png';
import jian3 from '../imgs/剪3.png';
import jian4 from '../imgs/剪4.png';



let editor;
let editor2;
let editor3;
let imgurl;
let maker;
function makeImageUrl(uid, process, ext) {
return baseURL + '/makeRelief/getImage/' + uid + '/' + process + ext;
}
const sampleImageUids = [
"sample,9a15e9fd6b0a4363926446a9a18be6f3",
"sample,febbec1995c94a3f8c1e7cf3229db14a",
"sample,bd5497c92f034ffc8f1a51f030950875",
"sample,ef2a9afc345f4804b67e6750408e75cf",
"sample,cd4302e9dcfd4ffa8af56d05b24f70e0",
"sample,935c758473a94ea288f0709c813055d5",
"sample,8cbed45f48954a6d942f9548ef57041f",
"sample,54bf14eb23414ad3bb5240ab73cfbfd4",
"sample,d91bdf2db495486f833d172cb3f75ebd",
"sample,354be159fd9e4ae3a3b4e80cef38a76d",
"sample,090ccdf08584441b9d3bbc65fcdf4c9c",
"sample,7ec2b0ba10684bb49e375536bd5d1f1f",
"sample,a1caf27741f04bf1970c2a92e5472173",
"sample,e128d2beb38c45d2b3a5aecddb793a41",
"sample,a79ea760d873497b861c6e4cf623b897",
"sample,e194dc126bc649afa8aa6efe54b776b9",
"sample,dae71371b786403a9db9c9b27467bbc5",
"sample,7e46627141f445698e9069ac33088523",
"sample,fde1e6c1f8584629a171a4f0def185ea",
"sample,bd53459cb3e84aa59b59973e86d1a08e"
];


export default {
name: "decorativePainting",
mixins: [printModel],
components: {
XDialog,
range: Range, radio: Radio, Group, Cell, loading, Checker, CheckerItem, XSwitch, XProgress, Box
},
data() {
return {
quotationName: "定制装饰画",
productType: "装饰画",
landscape: true,//竖屏状态要一直为true
showLoading: false,
showVaseBottom: false,
showReliefBottom: false,
showPrint: false,
showTabList: false,
showTabList1: false,
showCurve: false,
showBottle: false,
showIrregular: false,
showOwner: true,
isShareWork: false, // 是分享作品
addCartIndex: -1,
orderIndex: -1,
cur: 0, //默认选中第一个tab
cur1: 0,
cur2: 0,
cur3: 0,
btnsListIndex1: -1,
btnsListIndex2: -1,
btnsListIndex3: -1,
btnsListIndex4: -1,
disabled: false,
isframeIndex: 10,
isdecoraPainIndex: 0,
isdecorateIndex: 0,
isbaseIndex: 0,
ownerName: "",
ownerImg: "",
bottleData: 0,
choiceStyle: 0,
irregularData: 0,
ornamentData: 1,//默认摆件
rotationsWayData: "1",
pointCount: 5,
pointCount1: 5,//点的默认值
pointCount2: 4,//点的默认值
percent: 0,
showBottleData: false,//第二种（直线或者弧线）
showIrregularData: false,//第三种（直线或者弧线）
showRotations: false,//旋转
showRotationsWay: false,//旋转方式
showRepeatTimes: false,//边数




showBottleCanvas: false,//显示第二种
showIrregularCanvas: false,//显示第三种画布
noUpdateMesh: false,
showDownloads: false,
showRelief: false,
showBtnList1: true,
showBottomPop: false,
showPrintImg: true,
showdownloadImg: true,
showShareImg: true,

showPotImg: true,

showXiang: false,
showMenu: false,
showOrnamentPop: false,
showSetImg: true,
userUploadImages: [],
sampleImages: sampleImageUids.map(uid => makeImageUrl(uid, 'thumb', '.jpg')),
btnsList1: [





{
isClick: false,
icon: require("../imgs/设置.png"),
iconClick: require("../imgs/设置（选中）.png"),
},





],
tabTitle: [
{
title: '外框',
enabled: true,
},
{
title: '剪纸',
enabled: true,
},
{
title: '装饰',
enabled: true,
},
{
title: '底座',
enabled: false,
},
],
choiceStyleList: [{
key: 'circle',
title: '圆形'
}, {
key: 'polygon',
title: '正多边形'
}, {
key: 'curve',
title: '任意多边形'
}],
ornamentsList: [{
key: 'pendant',
title: '挂件'
}, {
key: 'ornaments',
title: '摆件'
}],
decorateList: [//装饰
{
src: decorate1,
},
{
src: decorate2,
},



{
src: decorate4,
},
{
src: decorate5,
},
{
src: decorate6,
},



{
src: decorate8,
},






{
src: decorate11,
},
],
frameList: [//边框
{
src: frame1,
},
{
src: frame2,
},
{
src: frame3,
},
{
src: frame4,
},
{
src: frame5,
},
{
src: frame6,
},
{
src: frame7,
},
{
src: frame8,
},
{
src: frame9,
},
{
src: frame10,
},
{
src: frame11,
},
{
src: frame12,
},
{
src: frame13,
},
{
src: frame14,
},
{
src: frame15,
},



],
decoraPainList: [//剪纸
{
src: decoraPain1,
},
{
src: decoraPain2,
},
{
src: decoraPain3,
},
{
src: decoraPain4,
},
],
bianList: [
{
src: bian1,
},
{
src: bian2,
},
{
src: bian3,
},
{
src: bian4,
},
{
src: bian5,
},
{
src: bian6,
},
{
src: bian7,
},
{
src: bian8,
},
{
src: bian9,
},
{
src: bian10,
},
{
src: bian11,
},
{
src: bian12,
},
{
src: bian13,
},
{
src: bian14,
},
{
src: bian15,
},



],
jianList: [
{
src: jian1,
},
{
src: jian2,
},
{
src: jian3,
},
{
src: jian4,
},
],
zhuangList: [
{
src: zhuang1,
},
{
src: zhuang2,
},



{
src: zhuang4,
},
{
src: zhuang5,
},
{
src: zhuang6,
},



{
src: zhuang8,
},






{
src: zhuang11,
},
],
baseList: [

]
}
},
mounted() {
const scope = this;
scope.showLoading = true;
scope.showVaseBottom = true;


scope.showMenu = true;

var mo = function (e) {
e.preventDefault();
}

initThree(scope.$refs.canvas);
scope.floor = createFloor();


const contentDOM = scope.$refs.decorativePainting;


const resize1 = function (e) {
if (!scope.$refs.canvas) return;


let w = scope.$refs.canvasBox.clientWidth;
let h = scope.$refs.canvasBox.clientHeight;



scope.$refs.canvas.width = w; 
scope.$refs.canvas.height = h; 



camera.aspect = w / h;

camera.updateProjectionMatrix();

renderer.setSize(w, h);
}

scope.init3d(contentDOM, camera, renderer, resize1);



var decorativePainting = this.$refs.tabList; 


var screenHeight = window.innerHeight;
window.onresize = function () {
if (screenHeight !== window.innerHeight) {

decorativePainting.style.bottom = 0 + "px";
decorativePainting.style.position = "absolute";
} else {

decorativePainting.style.bottom = 50 + "px";
decorativePainting.style.position = "fixed";
}
};
window.addEventListener("resize", onresize);


var interval;


decorativePainting.onfocus = function () {
interval = setInterval(function () {
decorativePainting.style.bottom = 0 + "px";
decorativePainting.style.position = "absolute";
}, 500)
};


decorativePainting.onblur = function () {
decorativePainting.style.bottom = 50 + "px";
decorativePainting.style.position = "fixed";
clearInterval(interval);
};


incRenderCount();
maker = new PaintingMaker(scene);
maker.alterLayer(0, decorate1, 0xe0e0e0);
maker.alterLayer(2, frame11, 0xa0a0a0);
maker.alterLayer(1, decoraPain1, 0xffffff);


scope.$nextTick(function () {
scope.$refs.decorativePainting.style.paddingTop = '0px';
scope.$refs.decorativePainting.style.overflow = 'hidden';
scope.$refs.canvasBox.addEventListener("touchmove", mo, false);

scope.loadData();
});

setTimeout(() => {
scope.showLoading = false;
}, 50);
},
watch: {
'ornamentData': function () {
this.isTopBtn();
this.showOrnamentPop = false;
if (this.ornamentData == 0) {
this.tabTitle[3].enabled = false;
} else {
this.tabTitle[3].enabled = true;
}
},
},
methods: {
updateMesh() {
if (this.noUpdateMesh) return;
this.showLoading = true;
incRenderCount();
},

isShowMenu() {
this.showMenu = !this.showMenu;
},

touchend() {
setTimeout(() => {
this.noUpdateMesh = false;
this.updateMesh();
this.showLoading = false;
console.log("4458585");
}, 1000);
},


loadData() {
const scope = this;
if (window.localStorage) {
let dataStr = localStorage.getItem("decorativePainting");
localStorage.removeItem("decorativePainting"); 
if (dataStr) {
scope.showLoading = true;
scope.noUpdateMesh = false;

let data = JSON.parse(dataStr);
scope.isframeIndex = data.isframeIndex;
scope.isdecoraPainIndex = data.isdecoraPainIndex;
scope.isdecorateIndex = data.isdecorateIndex;
} else {
console.log("err");
}
}

},


saveData() {
const scope = this;
if (window.localStorage) {
let data = {};
data.isframeIndex = scope.isframeIndex;
data.isdecoraPainIndex = scope.isdecoraPainIndex;
data.isdecorateIndex = scope.isdecorateIndex;
localStorage.setItem("decorativePainting", JSON.stringify(data));
}
},

handler1(index) {
this.btnsListIndex1 = index;
this.showSetImg = !this.showSetImg;
this.showTabList = !this.showTabList;
this.resize();
if (!this.showTabList) {
this.optimizedIndexClick();
this.optimizedBtnClick();
this.resize();
return;
}
return;


















},


downloadsBtn() {
this.isTopBtn();
this.showDownloads = !this.showDownloads;
this.showdownloadImg = !this.showdownloadImg;
},


downloads() {
const scope = this;
scope.showDownloads = false;
scope.showLoading = true;

if (maker.allInOne) {

if (!this.$common.getCookie('_token')) {

scope.saveData();

this.$router.push({
path: '/login',
query: {
fullPath: this.$route.fullPath
}
});
scope.showLoading = false;
} else {
scope.$request.post('/SmallSoftware/requestDownload', {
type: "vase",
}).then(function (res) {
console.log("res", res);
if (res.obj === true) {
scope.downloadModels();
setTimeout(() => {
scope.$vux.toast.show({
text: '下载成功',
type: "success",
time: 2000,
position: "middle",
});
scope.isTopBtn();
scope.showLoading = false;
}, 50);
} else {
scope.$vux.toast.show({
text: '下载失败',
type: "warn",
time: 2000,
position: "middle",
});
}
});
}
}
},

downloadModels() {
let exporter = new THREE.STLExporter();
let group = maker.allInOne;

let result = exporter.parse(group, { binary: true });
let blob = new Blob([result], { type: 'application/octet-stream' });

let filename = "装饰画.stl";
let link = document.createElement("a");
link.href = URL.createObjectURL(blob);
link.download = filename;
link.click();
console.log("downloadModels", link);
},

optimizedBtnClick() {
this.btnsList1[0].isClick = false;
this.showSetImg = true;

},

optimizedIndexClick() {
this.btnsListIndex1 = -1;



},

optimizedPopClick() {
this.showPrint = false;
this.showTabList = false;
this.showOrnamentPop = false;
this.showDownloads = false;
this.showdownloadImg = true;
this.showPrintImg = true;
},


isClickPot() {
this.isTopBtn();

this.$refs.btn_import.click();
},

onFileChange1(e) {
let file = e.target.files[0];
if (!file) {
return;
};


let formData = new FormData();
formData.append("img", file);
this.$request.post("/SmallSoftware/addImage", formData, {
headers: {
'Content-Type': 'multipart/form-data'
}
}).then(res => {
console.log(res);
this.userUploadImages.unshift({
uid: res.obj.img_uid,
ext: res.obj.ext
});
let url = URL.createObjectURL(file);


console.log("urel", this.userUploadImages);

this.isdecoraPainIndex = -2;

const scope = this;
scope.showLoading = true;















})
},


touchstart() {
this.isTopBtn();
this.resize();
},

isTopBtn() {
this.optimizedPopClick();
this.optimizedBtnClick();
this.optimizedIndexClick();
this.resize();
},




uploadPpictures0() {
const scope = this;
scope.isTopBtn();
scope.showLoading = true;
scope.isframeIndex = -1;
setTimeout(() => {
scope.noUpdateMesh = false;
scope.updateMesh();
scope.showLoading = false;
}, 50);
},

uploadPpictures1() {
const scope = this;
scope.isTopBtn();
scope.showLoading = true;
scope.isdecoraPainIndex = -1;
setTimeout(() => {
scope.noUpdateMesh = false;
scope.updateMesh();
scope.showLoading = false;
}, 50);
},

uploadPpictures2() {
const scope = this;
scope.isTopBtn();
scope.showLoading = true;
scope.isdecorateIndex = -1;
setTimeout(() => {
scope.noUpdateMesh = false;
scope.updateMesh();
scope.showLoading = false;
}, 50);
},

onFileChange1(e) {
let file = e.target.files[0];
if (!file) {
return;
};


let formData = new FormData();
formData.append("img", file);
this.$request.post("/SmallSoftware/addImage", formData, {
headers: {
'Content-Type': 'multipart/form-data'
}
}).then(res => {
console.log(res);
this.userUploadImages.unshift({
uid: res.obj.img_uid,
ext: res.obj.ext
});
let url = URL.createObjectURL(file);


console.log("urel", this.userUploadImages);

this.isdecoraPainIndex = -2;

const scope = this;
scope.showLoading = true;
let stampImage = new Image();
stampImage.crossOrigin = "anonymous";
setTimeout(() => {
stampImage.onload = function () {
let canvas = document.createElement("canvas");
canvas.width = stampImage.naturalWidth;
canvas.height = stampImage.naturalHeight;
let context = canvas.getContext("2d");
context.drawImage(stampImage, 0, 0, canvas.width, canvas.height);
stampData = context.getImageData(0, 0, canvas.width, canvas.height);
scope.updateMesh();
scope.showLoading = false;
};
stampImage.src = url;
}, 50);
})
},


selepredefinedItem(index) {
this.showLoading = true;
this.isframeIndex = index;
setTimeout(() => {
this.noUpdateMesh = false;
maker.alterLayer(2, this.frameList[this.isframeIndex].src, 0xa0a0a0);
this.showLoading = false;
}, 50);
},


seledecoraPainItem(index) {
this.showLoading = true;
this.isdecoraPainIndex = index;
setTimeout(() => {
this.noUpdateMesh = false;
maker.alterLayer(1, this.decoraPainList[this.isdecoraPainIndex].src, 0xffffff);
this.showLoading = false;
}, 50);
},


seleDecorateItem(index) {
this.showLoading = true;
this.isdecorateIndex = index;
setTimeout(() => {
this.noUpdateMesh = false;
maker.alterLayer(0, this.decorateList[this.isdecorateIndex].src, 0xe0e0e0);
this.showLoading = false;
}, 50);
},


selebaseItem(index) {
this.isbaseIndex = index;
},



resize() {
let w = document.documentElement.clientWidth;
let h = document.documentElement.clientHeight;
if (this.btnsListIndex1 == 0 || this.btnsListIndex1 == 1) {
let tabHeight = h * 0.2;
h = h - tabHeight;
}
camera.aspect = w / h;
camera.updateProjectionMatrix();
renderer.setSize(w, h);
incRenderCount();
},

closeCurvePop() {
this.isTopBtn();
},




pointReduce() {
if (this.pointCount <= 5) {
this.$vux.toast.show({
type: 'warn',
text: '点的数量不能少5'
});
} else {
this.pointCount--;
editor.redControlPoint();
editor.draw();
}
},
pointAdd() {
this.pointCount++;
editor.incControlPoint();
},

pointReduce1() {
if (this.pointCount1 <= 5) {
this.$vux.toast.show({
type: 'warn',
text: '点的数量不能少5'
});
} else {
this.pointCount1--;
editor2.redControlPoint();
editor2.draw();
}
},
pointAdd1() {
this.pointCount1++;
editor2.incControlPoint();
},

pointReduce2() {
if (this.pointCount2 <= 4) {
this.$vux.toast.show({
type: 'warn',
text: '点的数量不能少4'
});
} else {
this.pointCount2--;
editor3.redControlPoint();
editor3.updatePoints();
editor3.draw();
}
},
pointAdd2() {
this.pointCount2++;
editor3.incControlPoint();
editor3.updatePoints();
editor3.draw();
},

copy(str) {
var save = function (e) {
e.clipboardData.setData('text/plain', str);
e.preventDefault();
}
document.addEventListener('copy', save);
document.execCommand('copy');
document.removeEventListener('copy', save);
},


share() {
const scope = this;
scope.isTopBtn();
scope.showShareImg = !scope.showShareImg;
setTimeout(() => {
scope.showShareImg = false;
}, 1000);



if (!this.$common.getCookie('_token')) {

scope.saveData();

this.$router.push({
path: '/login',
query: {
fullPath: this.$route.fullPath
}
});
scope.showLoading = false;
} else {
this.$nextTick(function () {
let data = {};
data.isframeIndex = scope.isframeIndex;
data.userUploadImages = scope.userUploadImages;
data.isdecoraPainIndex = scope.isdecoraPainIndex;

if (scope.isdecoraPainIndex === -2) { // 是用户自己上传的图片：需要保存到oss中
scope.$request.post("/SmallSoftware/putImageToOSS", {
img_uid: scope.userUploadImages[0].uid,
ext: scope.userUploadImages[0].ext
}).then(res => {
data.isdecoraPainIndex = -3;
data.userUploadImageOnOSS = res.obj;
scope.$request.post('/SmallSoftware/share', {
type: "vase",
data: JSON.stringify(data)
}).then(function (res) {

scope.$vux.toast.show({
type: 'success',
text: '复制成功，去粘贴分享给微信好友吧'
});
let index = location.href.indexOf("?");
let url;
if (index >= 0) {
url = location.href.substr(0, index);
} else {
url = location.href;
}
scope.copy(url + "?work=" + res.obj);
console.log("url", url);
}).catch(function () {
scope.$vux.toast.show({
type: 'warn',
text: '分享失败'
});
});
}).catch(err => {
scope.$vux.toast.show({
type: 'warn',
text: '保存图片失败'
});
});
} else {
scope.$request.post('/SmallSoftware/share', {
type: "vase",
data: JSON.stringify(data)
}).then(function (res) {

scope.$vux.toast.show({
type: 'success',
text: '复制成功，去粘贴分享给微信好友吧'
});
let index = location.href.indexOf("?");
let url;
if (index >= 0) {
url = location.href.substr(0, index);
} else {
url = location.href;
}
scope.copy(url + "?work=" + res.obj);
console.log("url", url);
}).catch(function () {
scope.$vux.toast.show({
type: 'warn',
text: '分享失败'
});
});
}
});
}

scope.noUpdateMesh = false;
scope.updateMesh();
scope.showLoading = false;

},

getModelToPrint() {
return maker.allInOne;
},

makeStlBlob() {
let exporter = new THREE.STLExporter();
let group = maker.allInOne;

let result = exporter.parse(group, { binary: true });
let blob = new Blob([result], { type: 'application/octet-stream' });
return blob;
},

closePrint() {
this.isTopBtn();
},

getUploadUrl() {
return "/SmallSoftware/uploadFile";
},


print() {
this.modelSplit = true;
this.isTopBtn();
incRenderCount();
this.showLoading = true;
this.showPrintImg = !this.showPrintImg;

if (this.lowPrice == 0 && this.total <= 5 || this.total == 5) {
this.showlow = true;
this.showStyle = false;
this.showlowpriceHeight = true;
}
if (this.lowPrice == 1 && this.total > 5 || this.total > 5 || this.lowPrice == "") {
this.showlow = false;
this.showStyle = true;
this.showlowpriceHeight = false;
}

if (maker.allInOne) {
this.saveData();
this.$nextTick(function () {
this.showPrint = true;
this.makeModelForPrint();
this.getPrice();
});
} else {
this.$vux.toast.show({
text: '定制装饰画不能为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.noUpdateMesh = false;
this.updateMesh();
}

setTimeout(() => {
this.showLoading = false;
}, 50);
},
},
}



// WEBPACK FOOTER //
// ./src/views/decorativePainting/scripts/decorativePainting.js